import { moduleApi } from "@amtana/module";
import type { EraseStep } from "@amtana/module";

import type {
  ArchiveProjectsInput,
  ArchiveProjectsOutput,
  CreateProjectInput,
  ListProjectsInput,
  Project,
  ProjectList,
  RenameProjectInput,
  SelectProjectInput,
  UnarchiveProjectInput,
} from "./project.schemas.ts";

/** A project belongs to the organization (S2.03, ADR-001 §2); `userId` is the author
 * of a write, and whose own navigation state `current`/`select` reads or sets. */
type ForOrganization = { readonly userId: string; readonly organizationId: string };

export interface ProjectApi extends EraseStep {
  /** The plan's project limit is the organization's, read through billing. */
  list(input: ForOrganization & ListProjectsInput): Promise<ProjectList>;
  /** The project the caller is standing in, among their organization's; peers scope their reads by it. */
  current(input: ForOrganization): Promise<Project>;
  create(input: ForOrganization & CreateProjectInput): Promise<Project>;
  rename(input: ForOrganization & RenameProjectInput): Promise<Project>;
  /** Archives instead of deleting (S2.06): its analyses, campaigns and other data
   * stay reachable, just hidden by default. Refused for the default project. */
  archive(input: ForOrganization & ArchiveProjectsInput): Promise<ArchiveProjectsOutput>;
  unarchive(input: ForOrganization & UnarchiveProjectInput): Promise<Project>;
  select(input: ForOrganization & SelectProjectInput): Promise<Project>;
  /** Operator-only (D053): no transport door. Stamps rows left over from before S1.03. */
  backfillOrganizationId(): Promise<{ readonly assigned: number }>;
}

export const ProjectApi = moduleApi<ProjectApi>()("project");
